import type { Alpha3Code } from "i18n-iso-countries/index"
import { mixed, object, string, type InferType } from "yup"
import {
  NATIONAL_IDENTIFICATION_TYPES,
  type NationalIdentificationType,
} from "../../national-identification"
import { ALL_COUNTRIES } from "../../util/country"
import { dateISOString, isFutureDate, isPastDate } from "./date-iso-string"

export const nationalIdentificationSchema = object({
  identificationType: mixed<NationalIdentificationType>()
    .required()
    .oneOf([...NATIONAL_IDENTIFICATION_TYPES]),
  identificationNumber: string().required(),
  issuingCountry: mixed<Alpha3Code>().required().oneOf(ALL_COUNTRIES),
  issueDate: dateISOString()
    .optional()
    .test(isPastDate({ allowToday: true })),
  expiryDate: dateISOString()
    .optional()
    .test(isFutureDate({ allowToday: true })),
})

export type NationalIdentificationData = InferType<
  typeof nationalIdentificationSchema
>
